var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "622C99D5-C9B5-47F7-BEA7-455F98164CA7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CoreFit-Landing-Page-Option3",
    transform: "translate(-666.000000, -5139.000000)",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "footer",
    transform: "translate(0.000000, 4836.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Contact-us-grp",
    transform: "translate(665.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_mail",
    transform: "translate(12.000000, 230.000000) rotate(45.000000) translate(-12.000000, -230.000000) translate(5.000000, 221.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "rect4529",
    points: "6.86206442 0.112688387 13.7241288 17.0210292 6.86206442 13.8157157 0 17.0210292"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.80981836,
    y1: 0.621378876,
    x2: 6.78637052,
    y2: 13.4742541,
    id: "path4532",
    strokeWidth: 1.202223
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMail);
export default __webpack_public_path__ + "static/media/ic_mail.4e991e46013e39e4eb79a60466963619.svg";
export { ForwardRef as ReactComponent };